export function SET_NEMATODE_TEST(state, nematodeTest) {
  state.nematodeTest = nematodeTest;
}
